export default __webpack_public_path__ + "static/media/aunty2.0569f1f0.png";